import React, { useState } from "react";
import styles from "./index.module.scss";

const IMAGE_EXTENSIONS = new Set([".png", ".jpg", ".jpeg", ".svg", ".webp", ".gif"]);

export const isImageMessage = (text) => {
  if (!text || typeof text !== "string") {
    return false;
  }
  try {
    const parsed = new URL(text);
    const pathname = parsed.pathname.toLowerCase();
    return Array.from(IMAGE_EXTENSIONS).some((ext) => pathname.endsWith(ext));
  } catch (error) {
    return false;
  }
};

const ImageDisplay = ({ imageUrl }) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  if (!isImageMessage(imageUrl)) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setIsPreviewOpen(true)}
        className={styles.thumbnailBtn}
        aria-label="放大查看圖片"
      >
        <img className={styles.thumbnail} src={imageUrl} alt="上傳的寵物圖片" />
      </button>
      {isPreviewOpen && (
        <div
          className={styles.previewOverlay}
          role="dialog"
          aria-modal="true"
          aria-label="圖片預覽"
          onClick={() => setIsPreviewOpen(false)}
        >
          <button
            type="button"
            className={styles.previewClose}
            onClick={() => setIsPreviewOpen(false)}
            aria-label="關閉圖片預覽"
          >
            ×
          </button>
          <img
            className={styles.previewImage}
            src={imageUrl}
            alt="上傳的寵物圖片放大預覽"
            onClick={(event) => event.stopPropagation()}
          />
        </div>
      )}
    </>
  );
};

export default ImageDisplay;